import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuth();

  // If still loading, show spinner
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />
          <p className="text-muted-foreground">Caricamento...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, save the original path so we can deep-link back after login
  // (sessionStorage survives the OAuth round-trip too, unlike state.from)
  if (!isAuthenticated) {
    const target = `${location.pathname}${location.search}${location.hash}`;
    if (target && target !== '/') {
      try { sessionStorage.setItem('pendingRedirect', target); } catch {}
    }
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
